import BaseUrl from "../../../constants/BaseUrl";
import {
  ClearSignUpFieldsActionConst,
  ForgotPasswordUserIdActionConst,
  GetLandlordProfileActionConst,
  LoginActionConst,
  LogoutActionConst,
  RestoreStateActionConst,
  SignUpActionConst,
} from "../../constants/authActionConst";

export const UserLogInAction = (fields) => {
  return async (dispatch) => {
    dispatch({
      type: LoginActionConst.USER_LOGIN_REQUEST,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      email: fields.email,
      password: fields.password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}tenant/signIn`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          // Save login success to localStorage
          localStorage.setItem("loginSuccess", JSON.stringify(result));

          dispatch({
            type: LoginActionConst.USER_LOGIN_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: LoginActionConst.USER_LOGIN_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const ClearSignUpFieldsAction = () => {
  return async (dispatch) => {
    dispatch({
      type: ClearSignUpFieldsActionConst.SIGNUP_CLEAR,
    });
  };
};

export const GetTenantProfile = (userId, token) => {
  return async (dispatch) => {
    dispatch({
      type: GetLandlordProfileActionConst.GET_USER_PROFILE_REQ,
    });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}tenant/profile/getProfileDetails/${userId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: GetLandlordProfileActionConst.GET_USER_PROFILE_SUCCESS,
            result: result.data,
          });
        } else {
          dispatch({
            type: GetLandlordProfileActionConst.GET_USER_PROFILE_FAIL,
            result: result.message,
          });
        }
      })
      .catch((error) => console.error(error));

    return;
  };
};

export const LogoutAction = () => {
  return async (dispatch) => {
    // Clear localStorage
    localStorage.removeItem("loginSuccess");
    localStorage.removeItem("userCredentials");

    dispatch({
      type: LogoutActionConst.LOGOUT_ACTION,
    });
  };
};

export const UserSignUpAction = (fields) => {
  return async (dispatch) => {
    dispatch({
      type: SignUpActionConst.USER_SIGNUP_REQUEST,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      firstName: fields.firstName,
      lastName: fields.lastName,
      email: fields.email,
      password: fields.password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/auth/signUp`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: SignUpActionConst.USER_SIGNUP_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: SignUpActionConst.USER_SIGNUP_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const ForgotPasswordUserIdAction = (id) => {
  return async (dispatch) => {
    dispatch({
      type: ForgotPasswordUserIdActionConst.FORGOT_PASS_USER_ID,
      id: id,
    });
  };
};

export const ClearForgotPasswordUserIdAction = (id) => {
  return async (dispatch) => {
    dispatch({
      type: ForgotPasswordUserIdActionConst.CLEAR_USER_ID,
    });
  };
};

export const HydrateStateAction = () => {
  return async (dispatch) => {
    try {
      const loginSuccess = JSON.parse(localStorage.getItem("loginSuccess"));
      const userCredentials = JSON.parse(
        localStorage.getItem("userCredentials")
      );

      if (loginSuccess) {
        dispatch({
          type: RestoreStateActionConst.RESTORE_AUTH_STATE,
          payload: {
            loginSuccess,
            userCredentials,
          },
        });

        // If we have login data, fetch the latest profile
        dispatch(GetTenantProfile(loginSuccess.user._id, loginSuccess.token));
      }
    } catch (error) {
      console.error("Error hydrating auth state:", error);
    }
  };
};

// Helper function to check if we have valid login credentials
export const hasValidLoginCredentials = () => {
  try {
    const loginSuccess = localStorage.getItem("loginSuccess");
    if (!loginSuccess) return false;

    const parsedLogin = JSON.parse(loginSuccess);
    return parsedLogin && parsedLogin.user && parsedLogin.token;
  } catch (error) {
    console.error("Error checking login credentials:", error);
    return false;
  }
};
